const info = {
  title: '社会招聘',
  subTitle: '非常期待，你来和我们一起筑起这座梦想的高山。',
  img: require('@/assets/list/0.png'),
  input: '请输入职位进行搜索'
}

export {
  info
}
